module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADoSURBVHgBlVDLEYJADE2CMt7QDrALb0oFliB3DjoecXZcZcQuFEuwArQTS5Crn12zDKvAzcxkZ5O8l+QF4A/D3XYbAtERicI4jk/14l5KX3U6R9DaXwkxJE3UNwWtVJam6awB7HZz/k6+nc2TJIkkxHWZ4An4eFxLIHdkvz3f70BKeUPLqhPY7uz9OtAkHQvO8/wSBMEAEUcc9tpAY1TfkYimP+nou647blyjIabaUQGceaW51eB53imKIqA20IwWQiyU1ht7paIownKNl+Ms2qpNgQmyImgmHEowW8Zh1hZjCRpgadzEH1hgi+u78ldNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.png
// module id = PUL0
// module chunks = 1